import React, { FunctionComponent } from "react";

import Container, { ContainerProps } from "@mui/material/Container";
import FormControlLabel, {
  FormControlLabelProps,
} from "@mui/material/FormControlLabel";
import styled from "@mui/material/styles/styled";

import {
  NAV_BAR_Z_INDEX,
  MOBILE_NAV_HEIGHT,
} from "@app/analytics/components/MobileNav/styles";

import Button, { ButtonProps } from "@rui/Button";
import Checkbox from "@rui/Checkbox";
import { StickyContainer } from "@rui/styles";

export const StickyCalendarHeader = styled(StickyContainer)(({ theme }) => ({
  backgroundColor: "#FFF",
  [theme.breakpoints.down("mobile")]: {
    top: MOBILE_NAV_HEIGHT,
    zIndex: NAV_BAR_Z_INDEX,
  },
}));

export const TabContentContainer = styled<React.FC<ContainerProps>>((props) => (
  <Container maxWidth="xl" {...props} />
))(({ theme }) => ({
  flexGrow: 1,
  paddingBottom: theme.spacing(5),
  marginTop: theme.spacing(3),
}));

export const HeaderButton = styled<FunctionComponent<ButtonProps>>((props) => (
  <Button variant="outlined" {...props} />
))(({ theme }) => ({
  height: "40px",
  borderColor: theme.palette.shades.neutral[100],
  color: theme.palette.shades.neutral[500],
  minWidth: 0,
  "& .MuiButton-startIcon": {
    marginRight: 0,
  },
  "& .header-button__label": {
    display: "none",
  },
  [theme.breakpoints.up("md")]: {
    "& .MuiButton-startIcon": {
      marginRight: theme.spacing(1),
    },
    "& .header-button__label": {
      display: "inline",
    },
  },
}));

type FilterCheckboxProps = Omit<FormControlLabelProps, "control">;

export const FilterCheckbox = styled<FunctionComponent<FilterCheckboxProps>>(
  (props) => (
    <FormControlLabel
      {...props}
      control={<Checkbox disableRipple />}
      labelPlacement="start"
    />
  )
)(({ theme }) => ({
  marginLeft: theme.spacing(-1),
  justifyContent: "space-between",
  margin: 0,
  "& .MuiFormControlLabel-label": {
    fontSize: "0.875rem",
    color: theme.palette.shades.neutral[600],
    overflow: "hidden",
    marginRight: theme.spacing(1),
  },
  "& .MuiButtonBase-root": {
    padding: theme.spacing(0),
  },
  "& .checkbox__icon": {
    height: "15px",
    width: "15px",
    borderWidth: "2px",

    "&.checkbox__icon--checked": {
      borderColor: "#323232",
      "& svg": {
        fontSize: "20px",
        color: "#323232",
      },
    },
  },
}));
